import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DatacapBatchRecord, Transaction } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';
import { AppService } from './app.service';
import { FocuslinkService } from './focuslink.service';

@Injectable({
	providedIn: 'root',
})
export class FocuspayReportingService {
	batchRecords: BehaviorSubject<DatacapBatchRecord[]> = new BehaviorSubject<DatacapBatchRecord[]>([]);

	datacapTransactions: Transaction[] = [];

	constructor(private focuslink: FocuslinkService, public app: AppService) {}

	async fetchTransactionRecords(venueKey: number, merchantId: string, firstRecordToFetch: number, quantityToFetch: number) {
		const taskList = [];
		for (let i = firstRecordToFetch; i <= quantityToFetch + firstRecordToFetch; i++) {
			const startDate = this.app.moment().add(-i, 'days').format('MMDDYYYY');
			let maxBatchRecordNumber: number = 0;

			if (this.batchRecords.value.length > 0) {
				maxBatchRecordNumber = this.batchRecords.value[0].number;
				if (i > maxBatchRecordNumber) {
					break;
				}
			}

			if (!this.batchRecords.value.some((batch) => batch.businessDate === startDate)) {
				taskList.push(
					this.getTransactions(venueKey, merchantId, startDate)
						.then((data) => {
							data.forEach((trxn) => {
								if (!trxn) {
									console.log('trxn is null');
								}
							});
							return (this.datacapTransactions = this.datacapTransactions.concat(data));
						})
						.catch((err) => console.log(err))
				);
			}
		}
		await Promise.all(taskList);
		this.transactionToBatchRecord(this.datacapTransactions);
	}

	async getTransactions(venueKey: number, merchantId: string, startDate: string) {
		try {
			const resp = await this.focuslink.paymentsReportsDetail(venueKey, merchantId, startDate);
			return resp.Transactions.map((i) => {
				i.Summary.businessDate = startDate;
				return i;
			});
		} catch (error) {}
	}

	transactionToBatchRecord(transactions: Transaction[]) {
		const batchRecords: DatacapBatchRecord[] = [];
		transactions.forEach((transaction) => {
			if (transaction.Summary.Batch > 0) {
				const batchRecord = batchRecords.find((b) => b.number === transaction.Summary.Batch);
				if (batchRecord) {
					batchRecord.transactions.push(transaction);
					if (transaction.Summary.Status === 'Approved' && transaction.Summary.Captured === true) {
						batchRecord.amount += transaction.Summary.Amount;
						batchRecord.transactionCount += 1;
					}

					if (this.app.moment(transaction.Summary.TimeStamp).isBefore(batchRecord.startTime)) {
						batchRecord.startTime = transaction.Summary.TimeStamp;
					}
					if (this.app.moment(transaction.Summary.TimeStamp).isAfter(batchRecord.endTime)) {
						batchRecord.endTime = transaction.Summary.TimeStamp;
					}
				} else {
					const newBatchRecord = new DatacapBatchRecord({
						number: transaction.Summary.Batch,
						businessDate: transaction.Summary.businessDate,
						transactions: [transaction],
						startTime: transaction.Summary.TimeStamp,
						endTime: transaction.Summary.TimeStamp,
						amount: 0,
						transactionCount: 0,
					});

					if (transaction.Summary.Status === 'Approved' && transaction.Summary.Captured === true) {
						newBatchRecord.amount += transaction.Summary.Amount;
						newBatchRecord.transactionCount += 1;
					}

					batchRecords.push(newBatchRecord);
				}
			} else {
				const batchRecord = batchRecords.find(
					(batch) =>
						this.app.moment(batch.startTime).isSameOrAfter(transaction.Summary.TimeStamp) &&
						this.app.moment(batch.endTime).isSameOrBefore(transaction.Summary.TimeStamp)
				);
				if (batchRecord) {
					batchRecord.transactions.push(transaction);
					if (transaction.Summary.Status === 'Approved' && transaction.Summary.Captured === true) {
						batchRecord.amount += transaction.Summary.Amount;
						batchRecord.transactionCount += 1;
					}
				} else {
					//NOTHING I CAN DO HERE. I DON'T KNOW WHERE TO PUT THE RECORD
				}
			}
		});

		batchRecords.sort((a, b) => (a.number > b.number ? 1 : -1));
		batchRecords.reverse();
		this.batchRecords.next(batchRecords);
		this.app.loading(false);
	}
}
